import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { map } from 'rxjs'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'

@Injectable({
	providedIn: 'root',
})
export class PayoutService {
	constructor(private http: HttpClient) {}

	getClientPayoutList(body: any) {
		return this.http.post(`${ApiEndPoint.GetClientPayoutListApi}`, body)
	}
	getClientProfilePayout(body: any) {
		return this.http.post(`${ApiEndPoint.GetClientProfilePayoutApi}`, body)
	}

	getClientPendingCount(body: any) {
		return this.http.post(`${ApiEndPoint.GetClientPendingCountApi}`, body)
	}
	getClientProfilePendingPayoutCount(body: any) {
		return this.http.post(`${ApiEndPoint.GetClientPendingPayoutCountApi}`, body)
	}

	getClientPayoutDetails(id: any) {
		return this.http.get(`${ApiEndPoint.GetClientPayoutDetailsApi}?id=${id}`)
	}

	getServicePayoutDetails(id: any) {
		return this.http.get(
			`${ApiEndPoint.GetServiceProvidetPayoutDetailsApi}?id=${id}`
		)
	}

	acceptClientPayout(body: any) {
		return this.http.post(`${ApiEndPoint.AcceptClientPayoutApi}`, body)
	}
	rejectClientPayout(body: any) {
		return this.http.post(`${ApiEndPoint.RejectClientPayoutApi}`, body)
	}
	UploadclientPayoutImage(body: any) {
		return this.http.post(ApiEndPoint.UploadclientPayoutImageApi, body)
	}
	UploadSpImage(body: any) {
		return this.http.post(ApiEndPoint.UploadSpImageApi, body)
	}
	getSPPayoutList(body: any) {
		return this.http.post(`${ApiEndPoint.GetSPPayoutListApi}`, body)
	}

	getSpPendingCount(body: any) {
		return this.http.post(`${ApiEndPoint.SearchAllSPPayoutTabCounttApi}`, body)
	}
	acceptSPPendingPayout(body: any) {
		return this.http.post(`${ApiEndPoint.AcceptSPPendingPayoutApi}`, body)
	}
	getBranchPayoutMethods(BranchId: any) {
		return this.http.get(
			`${ApiEndPoint.GetBranchPayoutMethodsApi}?BranchId=${BranchId}`
		)
	}

	getSPPayoutTransactionList(body: any) {
		return this.http.post(`${ApiEndPoint.GetSPPayoutTransactionListApi}`, body)
	}
	getSPPendingPayoutCount(body: any) {
		return this.http.post(`${ApiEndPoint.GetSPPendingPayoutCountApi}`, body)
	}
}
